// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const HookRegistration = lazy(
  () => import('pages/hookRegistration/hookRegistration')
);
const HookRegistrationList = lazy(
  () => import('pages/hookRegistration/hookRegistrationList')
);

const HookRegistrationRoute = (
  <Route path={routeName.hookRegistration}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.ALL_HOOK_REGISTRATION_VIEW,
            PrivateRouteConst.SELF_HOOK_REGISTRATION_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <HookRegistrationList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        // <PrivateRoute name={PrivateRouteConst.CREATE_HOOK_REGISTRATION}>
        <Suspense fallback={<Loading />}>
          <HookRegistration type="Create" />
        </Suspense>
        // </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        // <PrivateRoute
        //   name={[
        //     PrivateRouteConst.ALL_HOOK_REGISTRATION_EDIT,
        //     PrivateRouteConst.SELF_HOOK_REGISTRATION_EDIT,
        //   ]}
        // >
        <Suspense fallback={<Loading />}>
          <HookRegistration type="Edit" />
        </Suspense>
        // </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        // <PrivateRoute
        //   name={[
        //      PrivateRouteConst.ALL_HOOK_REGISTRATION_VIEW,
        //     PrivateRouteConst.SELF_HOOK_REGISTRATION_VIEW,
        //   ]}
        // >
        <Suspense fallback={<Loading />}>
          <HookRegistration type="Show" />
        </Suspense>
        // </PrivateRoute>
      }
    />
  </Route>
);

export default HookRegistrationRoute;
